declare global {
  interface Window {appConfig: {[key: string]: any}}
}
export default function getConfigProp (prop: string) {
  return window.appConfig[prop];
}